import { render, staticRenderFns } from "./PersonInfo.vue?vue&type=template&id=127de26a&scoped=true&"
import script from "./PersonInfo.vue?vue&type=script&lang=js&"
export * from "./PersonInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonInfo.vue?vue&type=style&index=0&id=127de26a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127de26a",
  null
  
)

export default component.exports